module.exports = __webpack_public_path__ + "static/img/img-background-4-croped.41530ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-4-croped.jpg
// module id = q7S9
// module chunks = 36